export default __webpack_public_path__ + "static/media/07AW1SEP66.cc601b9c.jpg";